import React, { useEffect } from 'react';
import './notification.css';

const Notification = ({ type, message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`inspira-notification inspira-notification--${type}`}>
      <span>{message}</span>
      <button className="inspira-notification__close-btn" onClick={onClose}>
        &times;
      </button>
    </div>
  );
};

export default Notification;
